module.exports = __webpack_public_path__ + "img/close.bef812bf.png";